
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';

/**
   * @component HowItWorksNote
   *
   * @private
   */

export default {
  name: 'HowItWorksNote',
  components: { Typography },
  data() {
    return { TypographyType };
  },
};
